import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalsDataTransferService } from 'src/app/core/services/modalService/modals-data-transfer.service';
import { selectBoxItem } from 'src/app/core/interfaces/interfaces';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-select-box-modal-gender',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './select-box-modal-gender.component.html',
  styleUrl: './select-box-modal-gender.component.scss',
})
export class SelectBoxModalGenderComponent implements OnInit {
  items: Array<selectBoxItem> = [];
  genderSelected!: any;

  constructor(private modalDataTransferService: ModalsDataTransferService) {
    this.items = this.modalDataTransferService.getSelectedBoxItemsGender();
  }
  ngOnInit(): void {
    this.genderSelected = this.modalDataTransferService.getSelectedItemInSelectBoxGender();
  }
  selectItem(item: selectBoxItem) {
    this.modalDataTransferService.selectItemInSelectBoxGender(item);
  }
}
